module.exports = __webpack_public_path__ + "img/logoe1.72bdc685.png";